
import * as React from "react"
import * as ProgressPrimitive from "@radix-ui/react-progress"

import { cn } from "@/lib/utils"

interface ProgressProps extends React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> {
  /**
   * Accessibility label for screen readers
   */
  ariaLabel?: string;
  /**
   * Descriptive text of the current value for screen readers
   */
  ariaValueText?: string;
}

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  ProgressProps
>(({ className, value, ariaLabel, ariaValueText, ...props }, ref) => {
  // Calculate percentage for aria attributes if not provided
  const percentage = value != null ? Math.round(value) : 0;
  const valueText = ariaValueText || `${percentage}%`;
  
  return (
    <ProgressPrimitive.Root
      ref={ref}
      className={cn(
        "relative h-4 w-full overflow-hidden rounded-full bg-secondary",
        className
      )}
      {...props}
      value={value}
      aria-label={ariaLabel}
      aria-valuetext={valueText}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <ProgressPrimitive.Indicator
        className="h-full w-full flex-1 bg-brand-blue transition-all"
        style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
      />
    </ProgressPrimitive.Root>
  )
})
Progress.displayName = ProgressPrimitive.Root.displayName

export { Progress }
